import attendanceApi from "@/services/api/attendance";
import { CustomSnackbar, severityType } from "@/utils/alert";
import { delay } from "@/utils/delay";
import { formataDataEmDDMMYYYYHM } from "@/utils/formatDateTo";
import styles from './Montagem.module.css'
import { IconButton, Divider, Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useClient } from "@/contexts/ClientContext";

interface MontagemProps {
    idAtendimento: number
}

export function Montagem({ idAtendimento }: MontagemProps) {
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState<{
        severity: severityType
        message: string
    }>({ severity: 'success', message: '' })
    const [estado, setEstado] = useState('')
    const [atualizarEstado, setAtualizarEstado] = useState('')
    const [montagem, setMontagem] = useState({
        dataEnvio: '',
        mensagem: '',
        atualizadoEm: ''
    })
    const [loading, setLoading] = useState({ montagem: false });
    const [expanded, setExpanded] = useState({ geral: false, montagem: false });
    const [errorsMontagem, setErrorsMontagem] = useState({ data: false, mensagem: false });
    const clientContext = useClient()

    function handleInputChangeMontagem(e: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = e.target;
        setMontagem((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    function togglspread(section: keyof typeof expanded) {
        setExpanded((prev) => ({ ...prev, [section]: !prev[section] }));
    }

    async function buscarAtendimento() {
        try {
            const resposta = await attendanceApi.getAttendance(idAtendimento)
            const data = resposta.data
            setAtualizarEstado(data.atualizadoEm)
            setEstado(data.estado)
            setMontagem({
                dataEnvio: data.data_envio_montagem,
                mensagem: data.mensagem_montagem,
                atualizadoEm: data.atualizadoEm_montagem
            })

        } catch (err) {
            setAlertInfo({
                severity: 'error',
                message: 'Erro ao buscar atendimento.',
            });
            setShowAlert(true);
        }
    }

    async function concluirEtapa(tipo: string) {
        try {
            if (tipo === 'Montagem') {
                await attendanceApi.atualizarEstadoAtendimento(idAtendimento.toString(), 'Feedback')
            } else {
                await attendanceApi.atualizarEstadoAtendimento(idAtendimento.toString(), tipo)
            }
            await buscarAtendimento()
            clientContext.reloadClientes()
            setAlertInfo({ severity: 'success', message: 'Etapa concluída!' });
            setShowAlert(true);
        } catch (err) {
            setAlertInfo({
                severity: 'error',
                message: 'Erro ao concluir etapa.',
            });
            setShowAlert(true);
        }
    }

    async function enviarMensagemParaCliente(tipo: string) {
        setAlertInfo({ severity: 'success', message: 'Mensagem enviada com sucesso!' });
        setShowAlert(true);
        try {
            if (!validateCamposMontagem()) {
                return
            }

            setLoading({ ...loading, montagem: true });
            await attendanceApi.atualizarMensagemAtendimento(idAtendimento.toString(), tipo, montagem.mensagem, new Date(montagem.dataEnvio).toISOString())
            await delay(1000)

        } catch (error) {
            setAlertInfo({
                severity: 'error',
                message: 'Erro ao enviar mensagem.',
            });
            setShowAlert(true);
        } finally {
            setLoading({ montagem: false });
        }
    }

    function validateCamposMontagem() {
        const newErrors = {
            montagemData: montagem.dataEnvio === '',
            montagemMensagem: montagem.mensagem === '',
        };
        setErrorsMontagem((prevErrors) => ({ ...prevErrors, ...newErrors }));

        return !Object.values(newErrors).includes(true);
    }

    useEffect(() => {
        buscarAtendimento()
    }, [])

    function handleAlertClose() {
        setShowAlert(false)
    }

    const isMontagemFeedback = estado === 'Feedback' || estado === 'Venda Concluída'

    return (
        <>
            {expanded.geral ? (
                <>
                    <CustomSnackbar
                        open={showAlert}
                        severity={alertInfo.severity}
                        message={alertInfo.message}
                        handleClose={handleAlertClose}
                    />
                    <>
                        <div className={styles.cabecalho_container}>
                            <div className={styles.cabecalho}>
                                {isMontagemFeedback ? (
                                    <CheckCircleIcon className={styles.etapa_concluida} />
                                ) : (
                                    <RadioButtonUncheckedIcon
                                    />
                                )}
                                <div className={styles.titulo_info}>
                                    <h4>Montagem</h4>

                                    {(atualizarEstado !== '' && isMontagemFeedback) && (
                                        <span>
                                            Útima modificação {formataDataEmDDMMYYYYHM(new Date(atualizarEstado))}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className={''}>
                                <IconButton onClick={() => togglspread('geral')}>
                                    <ExpandLessIcon fontSize='large' />
                                </IconButton>
                            </div>
                        </div>

                        <Divider style={{ marginBottom: '1rem' }} />
                    </>

                    <div className={styles.formulario_producao_container}>
                        <div className={`${styles.montagem_container} ${isMontagemFeedback && styles.estado_montagem_container}`}>
                            <div className={styles.cabecalho}>
                                <div className={styles.titulo}>
                                    {isMontagemFeedback ? (<CheckCircleIcon />) : (<RadioButtonUncheckedIcon />)}

                                    <div className={styles.titulo_info}>

                                        <h4>Montagem</h4>

                                        {isMontagemFeedback && (
                                            <span>
                                                Ultima modificação: {formataDataEmDDMMYYYYHM(new Date(montagem.atualizadoEm))}
                                            </span>
                                        )
                                        }
                                    </div>
                                </div>

                                <div className={`${styles.acao_toggle} ${isMontagemFeedback ? styles.acao_toggle_montagem : ''}`}>
                                    <Button
                                        startIcon={<CheckCircleIcon />}
                                        className={styles.concluir_etapa}
                                        onClick={() => concluirEtapa('Montagem')}
                                        disabled={isMontagemFeedback}
                                    >
                                        {isMontagemFeedback ? 'ETAPA CONCLUIDA' : 'CONCLUIR ETAPA'}
                                    </Button>

                                    <div className={''}>
                                        {expanded.montagem ? (
                                            <IconButton onClick={() => togglspread('montagem')}>
                                                <ExpandLessIcon fontSize='large' />
                                            </IconButton>
                                        ) :
                                            <IconButton onClick={() => togglspread('montagem')}>
                                                <ExpandMoreIcon fontSize='large' />
                                            </IconButton>
                                        }
                                    </div>
                                </div>

                            </div>

                            <Divider style={{ marginBottom: '3rem', }} />

                            {expanded.montagem && (
                                <form>
                                    <TextField
                                        id="outlined-basic"
                                        label="Data de agendamento"
                                        variant="outlined"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        name="dataEnvio"
                                        fullWidth
                                        value={montagem.dataEnvio ? new Date(montagem.dataEnvio).toISOString().split("T")[0] : ""}
                                        onChange={handleInputChangeMontagem}
                                        error={errorsMontagem.data}
                                        helperText={errorsMontagem.data ? "Campo obrigatório" : ""}
                                    />

                                    <TextField
                                        name="mensagem"
                                        type='text'
                                        label='Mensagem'
                                        variant='outlined'
                                        multiline
                                        fullWidth
                                        value={montagem.mensagem}
                                        onChange={handleInputChangeMontagem}
                                        error={errorsMontagem.mensagem}
                                        helperText={errorsMontagem.mensagem ? "Campo obrigatório" : ""}
                                        sx={{
                                            '& .MuiInputBase-input': {
                                              maxHeight: '100px',
                                              overflowY: 'auto'
                                            },
                                            '& textarea': {
                                              overflowY: 'auto !important'
                                            }
                                          }}
                                    />

                                    <div className={styles.box_buttons}>
                                        <Button
                                            className={styles.enviar_mensagem}
                                            type='button'
                                            variant='contained'
                                            onClick={() => enviarMensagemParaCliente('Montagem')}
                                            disabled={isMontagemFeedback}
                                        >
                                            {loading.montagem ? 'Enviando...' : 'ENVIAR MENSAGEM'}
                                        </Button>

                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className={styles.cabecalho_container}>
                        <div className={styles.cabecalho}>
                            {isMontagemFeedback ? (
                                <CheckCircleIcon className={styles.etapa_concluida} />
                            ) : (
                                <RadioButtonUncheckedIcon
                                />
                            )}

                            <div className={styles.titulo_info}>
                                <h4>Montagem</h4>

                                {(atualizarEstado !== '' && isMontagemFeedback) && (
                                    <span>
                                        Útima modificação {formataDataEmDDMMYYYYHM(new Date(atualizarEstado))}
                                    </span>
                                )}

                            </div>
                        </div>

                        <div className={''}>
                            {isMontagemFeedback && (
                                <span className={styles.processo_concluido}>Processo concluído</span>
                            )}
                            <IconButton onClick={() => togglspread('geral')}>
                                <ExpandMoreIcon fontSize='large' />
                            </IconButton>
                        </div>
                    </div>

                    <Divider component='li' style={{ listStyle: 'none' }} />
                </>
            )}
        </>
    )
}